import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";
import { useEvalStewardEnabled } from "./useEvalStewardEnabled";

export interface EvalAnnotationParams {
  workspaceId: string;
  annotationId: string | null | undefined;
}

export function useEvalAnnotation({
  workspaceId,
  annotationId,
}: EvalAnnotationParams) {
  const { isEvalStewardEnabled } = useEvalStewardEnabled();

  return useQuery({
    queryKey: ["evalSteward", "evalAnnotation", workspaceId, annotationId],
    queryFn: () => api.getEvalAnnotation(workspaceId, annotationId!),
    enabled:
      isEvalStewardEnabled && Boolean(workspaceId && annotationId),
  });
}
